import {useTranslation} from 'react-i18next'
import ConverterDropZone from '../converterShared/ConverterDropZone'
import {useConverterImageUpload} from './useConverterImageUpload'
import {CONVERTER_INPUT_ACCEPT} from '../../../common/constants/converterFormats'

interface ImageSourceUploadProps {
  image: HTMLImageElement | null
  onImageLoaded: (image: HTMLImageElement, isAnimatedGif: boolean) => void
  onClear: () => void
}

const ImageSourceUpload = ({image, onImageLoaded, onClear}: ImageSourceUploadProps) => {
  const {t} = useTranslation()
  const {busy, error, handleFileSelected} = useConverterImageUpload(image !== null, onImageLoaded)

  return (
    <ConverterDropZone
      accept={CONVERTER_INPUT_ACCEPT}
      busy={busy}
      hasFile={image !== null}
      pickLabel={t('imageConverter.upload.pick')}
      replaceLabel={t('imageConverter.upload.replace')}
      clearLabel={t('imageConverter.upload.clear')}
      busyLabel={t('imageConverter.upload.busy')}
      hint={t('imageConverter.upload.hint')}
      error={error}
      onFileSelected={handleFileSelected}
      onClear={onClear}
    >
      {image && (
        <div className="imc-upload-thumb">
          <img src={image.src} alt={t('imageConverter.upload.previewAlt')} />
        </div>
      )}
    </ConverterDropZone>
  )
}

export default ImageSourceUpload
